<template>
  <div class="gray-back">
    <van-tabs v-model="active" class="tab-nav" sticky @click="onStatusChange">
      <van-tab title="正常"></van-tab>
      <van-tab title="隐藏"></van-tab>
    </van-tabs>
    <div class="box">


      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <div class="kaojicenter-list-box">
            <div class="kaojicenter-lists flex-between" v-for="(item, index) in list"
                 @click="action(item, index)">
              <div class="kaojicenter-rights">
                <div class="title">{{ item.name }}</div>
                <div class="desc flex-start">
                  <van-tag round v-if="item.cert_status==1" type="success">已认证</van-tag>
                  <van-tag round v-else-if="item.cert_status==3">认证失败</van-tag>
                  <van-tag round v-else-if="item.cardtype==1 && item.cert_status==2" type="warning">未认证</van-tag>
                  <van-tag round plain v-else-if="item.cardtype!=1 && item.cert_status==2">无需认证</van-tag> &nbsp;
                  {{ item.num }}
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>

      <van-action-sheet v-model="actionShow" :actions="actions" @select="onActionSelect"/>

        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="
    bottom: 80px;
    right: 10px;
    position: fixed;"
            size="normal" round
            @click="onTongbu"
            >同步CCA官网
        </van-button>
      <div class="savebtn">
        <van-button
            style="width: 2rem"
            size="normal" round
            @click="onShareParent"
            >分享家长
        </van-button>
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 2rem"
            size="normal" round @click="showTemplate = true">导入模板
        </van-button>
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 2rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
            @click="addShow=true">新增
        </van-button>
      </div>


      <van-popup
          position="bottom"
          :style="{ height: '60%' }"
          v-model="addShow"
          @click-overlay="addShow=false"
      >
        <div style="margin-top: 0.2rem ; margin-bottom: 1.5rem">
          <van-form
              @submit="onSubmit"
              @failed="onFailed"
          >
            <van-divider>新增运动员</van-divider>
            <van-cell-group>
              <van-field
                  v-model="formData.name"
                  label="姓名"
                  :rules="[{ required: true, message: '姓名不能为空' }]"
                  error-message-align="right"
                  input-align="right"
                  clearable
                  placeholder="请输入姓名"
              />
              <van-field
                  readonly
                  clickable
                  right-icon="arrow"
                  input-align="right"
                  @click="showNumTypePicker=true"
                  label="证件类型"
                  v-model="formData.numTypeName"
              />
              <van-popup v-model="showNumTypePicker" position="bottom">
                <van-picker :columns="numTypeColumns"
                            show-toolbar
                            :default-index="formData.cardtype-1"
                            @cancel="showNumTypePicker = false"
                            @confirm="onNumTypeConfirm"
                />
              </van-popup>


              <van-field
                  v-if="formData.cardtype==1"
                  v-model="formData.num"
                  :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                  error-message-align="right"
                  label="身份证号"
                  input-align="right"
                  clearable
                  placeholder="请输入身份证号"
              />

              <van-field
                  v-model="formData.huzhao"
                  v-if="formData.cardtype!=1"
                  label="证件号码"
                  :rules="[{ required: true, message: '证件号码不能为空' }]"
                  error-message-align="right"
                  input-align="right"
                  clearable
                  placeholder="请输入证件号码"
              />

              <van-field
                  v-if="showBirthday"
                  readonly
                  clickable
                  label="生日"
                  input-align="right"
                  error-message-align="right"
                  placeholder="请选择生日"
                  v-model="formData.birthday"
                  :rules="[{ required: true, message: '请选择生日' }]"
                  @click="showDate = true"/>

              <van-popup v-model="showDate" position="bottom">

                <van-datetime-picker
                    type="date"
                    title="选择年月日"
                    v-model="currentDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="onDateConfirm"
                    @cancel="showDate=false"
                />
              </van-popup>


              <van-field
                  v-if="showSex"
                  name="radio" label="性别"
                  input-align="right">
                <template #input>
                  <van-radio-group v-model="formData.sex" direction="horizontal">
                    <van-radio checked-color="#ffb01b" :name="1">男</van-radio>
                    <van-radio checked-color="#ffb01b" :name="2">女</van-radio>
                  </van-radio-group>
                </template>
              </van-field>


              <van-field
                  v-if="showJianhu"
                  v-model="formData.jianhuname"
                  label="监护人姓名"
                  :rules="[{ required: true, message: '监护人姓名不能为空' }]"
                  error-message-align="right"
                  input-align="right"
                  clearable
                  placeholder="请输入监护人姓名"
              />

              <van-field
                  v-if="showJianhu"
                  v-model="formData.jianhunum"
                  label="监护人证件号码"
                  :rules="[{ required: true, message: '监护人证件号码不能为空' }]"
                  error-message-align="right"
                  input-align="right"
                  clearable
                  placeholder="请输入监护人证件号码"
              />

              <van-field
                  v-model="formData.jianhuphone"
                  label="监护人手机"
                  :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                  error-message-align="right"
                  input-align="right"
                  clearable
                  placeholder="请输入监护人手机"
              />



                        <van-field
                                v-model="formData.phonecode"
                                label="验证码"
                                :rules="[{ required: true,message:'请输入验证码'}]"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入验证码"
                        >
                        <template #button>
                        <van-button @click="getCode('')" native-type="button" size="small" type="primary" :disabled="clockSecond>0">{{clockSecond>0?
                    '('+clockSecond+'s)':'获取验证码'}}</van-button>
                        </template>
                        </van-field>

            </van-cell-group>

            <IdCardPicker title="运动员身份证识别(拍照/照片)"
                          style="margin: 0 auto; margin-top: 20px; width: 4rem; text-align: center; border-radius: 1rem; border: 1px solid #eee ;  line-height: 0.6rem"
                          @success="onIdSuccess"/>

            <IdCardPicker v-show="showJianhu" title="监护人身份证识别(拍照/照片)"
                          style="margin: 0 auto; margin-top: 20px; width: 4rem; text-align: center; border-radius: 1rem; border: 1px solid #eee ;  line-height: 0.6rem"
                          @success="onFamilyIdSuccess"/>


            <div class="savebtn">
              <van-button
                  color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem"
                  size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
                  native-type="submit">保存
              </van-button>
            </div>
          </van-form>
        </div>
      </van-popup>



      <van-popup
          position="bottom"
          :style="{ height: '60%' }"
          v-model="jianhuFormShow"
          @click-overlay="jianhuFormShow=false"
      >
        <div style="margin-top: 0.2rem ; margin-bottom: 1.5rem">
          <van-form
              @submit="onJianhuSubmit"
              @failed="onFailed"
          >
            <van-divider>修改监护人信息</van-divider>
            <van-cell-group>
              <van-field
                  v-model="formData2.name"
                  label="姓名" 
                  readonly
                  error-message-align="right"
                  input-align="right" 
              /> 


              <van-field
                  v-model="formData2.jianhuname"
                  label="监护人姓名"
                  :rules="[{ required: true, message: '监护人姓名不能为空' }]"
                  error-message-align="right"
                  input-align="right"
                  clearable
                  placeholder="请输入监护人姓名"
              />

              <van-field 
                  v-model="formData2.jianhunum"
                  label="监护人证件号码"
                  :rules="[{ required: true, message: '监护人证件号码不能为空' }]"
                  error-message-align="right"
                  input-align="right"
                  clearable
                  placeholder="请输入监护人证件号码"
              />

              <van-field
                  v-model="formData2.jianhuphone"
                  label="监护人手机"
                  :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                  error-message-align="right"
                  input-align="right"
                  clearable
                  placeholder="请输入监护人手机"
              />



                        <van-field
                                v-model="formData2.phonecode"
                                label="验证码"
                                :rules="[{ required: true,message:'请输入验证码'}]"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入验证码"
                        >
                        <template #button>
                        <van-button @click="getCode(2)" native-type="button" size="small" type="primary" :disabled="clockSecond>0">{{clockSecond>0?
                    '('+clockSecond+'s)':'获取验证码'}}</van-button>
                        </template>
                        </van-field>

            </van-cell-group>
 
            <IdCardPicker v-show="jianhuFormShow" title="监护人身份证识别(拍照/照片)"
                          style="margin: 0 auto; margin-top: 20px; width: 4rem; text-align: center; border-radius: 1rem; border: 1px solid #eee ;  line-height: 0.6rem"
                          @success="onFamilyIdSuccess"/>


            <div class="savebtn">
              <van-button
                  color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem"
                  size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
                  native-type="submit">保存
              </van-button>
            </div>
          </van-form>
        </div>
      </van-popup>



    </div>
    <van-dialog v-model="showTemplate" title="导入模板信息">
      <div class="operate-desc-left" v-clipboard:copy="temaplate_share"
           v-clipboard:success="onCopy"
           v-clipboard:error="onError" style="color: #666">导入模板链接地址：{{temaplate_share}}</div>
      <div class="operate-desc-left" @click="download" style="color: #1989fa;">运动员批量导入模版下载</div>
    </van-dialog>

  </div>
</template>
<style scoped>

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.kaojicenter-list-box {
  padding-top: 0.2rem;
  /*background: rgba(248,248,248,1);*/
}

.goods-line {
  height: 55px;
}

.goods-bottom-line {
  width: 100%;
  position: fixed;
  height: 60px;
  bottom: 0;
  background: linear-gradient(180deg, hsla(255, 0%, 100%, 0), #fff);
}

.goods-create-btn {
  position: fixed;
  bottom: 10px;
  width: 100%;
  height: 44px;
  font-size: 16px;
  text-align: center;
}

.goods-create-btn button {
  width: 3.2rem;
}

.goods-create-btn img {
  width: 60px;
  height: 60px;
}

.goods-header {
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  margin-bottom: 0.01rem;
  background: #fff;
}

.van-tabs {
  /*width: 85% !important;*/
}

.screen-btn {
  line-height: 44px;
  height: 44px;
}

.screen-btn img {
  width: 45%;
  padding-left: 15px;
  vertical-align: middle;
  border-left: 1px solid #D5D5D5;
}

.sidebar {
  padding-top: 15px;
}

.search-box img {
  width: 60px;
  height: 60px;
}


.select-btn {
  position: fixed;
  bottom: 0;
  width: 90%;
  margin: 0 auto;
  padding: 0px 15px 30px;
}

.btn-reset {
  padding-bottom: 10px;
}

.btn-reset >>> .van-button {
  background: #ddd;
}

.selected {
  color: #444;
}


.kaojicenter-lists {
  padding: 0.2rem;
  border-radius: 10px;
  background: #fff;
  margin: 0 0.2rem 0.2rem;
}

.kaojicenter-lefts {
  position: relative;
}


.kaojicenter-lefts .img {
  border-radius: 10px;
  width: 1rem;
  height: 1rem;
}

.kaojicenter-rights {
  width: calc(100% - 1.2rem);
  position: relative;
  height: 1rem;
}

.kaojicenter-rights .title {
  font-size: 15px;
  font-weight: bold;
}

.kaojicenter-rights .desc {
  font-size: 12px;
  padding-top: 10px;
  color: #999;
}


</style>

<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import IdCardPicker from "../../../components/picker/IdCardPicker.vue";

import {
  Cell,
  CellGroup,
  Toast,
  Dialog,
  Icon,
  PullRefresh,
  List,
  Tag,
  Button,
  DropdownMenu,
  DropdownItem,
  DatetimePicker
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(DropdownItem).use(DatetimePicker);
export default {
  name: 'YundongyuanList',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    IdCardPicker
  },
  data: function () {
    return {
      validator,
      id: 0,
      active: 0,
      showDate: false,
      jianhuFormShow: false,
      showTemplate: false,
      actionShow: false,
      addShow: false,
      list: [],
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照', '其他身份证明'],
      actions: [
        {name: '隐藏'},
        {name: '认证'},
      ],
      params: {
        pageNo: 1,
        pageSize: 10,
        keywords: '',
        cate_id: 0,
        is_show: 1
      },
      formData: {
        name: '',
        num: '',
        huzhao: '',
        cardtype: 1,
        birthday: '',
        sex: 1,
        numTypeName: '身份证',
        jianhuname: '',
        jianhunum: '',
        jianhuphone: '',
      },
      formData2: {
        name: '',
        num: '',
        huzhao: '',
        cardtype: 1,
        birthday: '',
        sex: 1,
        numTypeName: '身份证',
        jianhuname: '',
        jianhunum: '',
        jianhuphone: '',
      },
      saveLoading: false,
      isLoading: false,
      loading: false,
      finished: false,

      share_data: {},
      parent_share: '',
      temaplate_share: '',
      clockSecond:0,

    }
  },
  mounted() {
    document.title = "运动员管理"
    this.getList();
    this.getShare();
  },
  computed: {
    showBirthday() {
      return this.formData.cardtype != 1;
    },
    showSex() {
      return this.formData.cardtype != 1;
    },
    showJianhu() {
      return this.formData.cardtype != 1 || (item => {
        if (this.formData.num.trim().length == 18) {
          var year = Number(this.formData.num.trim().substr(6, 4));
          var curYear = new Date().getFullYear();
          if (curYear - year < 18) {
            return true
          }
        }
      })();
    }
  },
  filters: {
    cert(value) {
      switch (value) {
        case 1 :
          return '#ff0000'
          break;
        case 2 :
          return '#FF9966'
          break;
        case 3 :
          return '#FFFF33'
          break;

      }
    }
  },
  destroyed() {
  },
  methods: {
    getShare() {
      let that = this;
      that.$api.get('/api/yundongyuan/yundongyuanShare', {}, (res) => {
        that.temaplate_share = res.data.temaplate_share
        that.parent_share = res.data.parent_share

        this.share_data ={
          desc: "",
          pic_url: "",
          title: document.title,
          url:  res.data.parent_share
        }
      })
    },
    getList() {
      let that = this;
      that.$api.get('/api/yundongyuan/yundongyuanList', that.params, (res) => {
        that.loading = false;

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          that.list = res.data.list
        } else {
          let list = that.list.concat(res.data.list);

          that.list = list;
        }

        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.pageNo += 1;
      })
    },


    // 上拉加载
    // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
    // 可以延迟异步的时间
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log('this.params.pageNo')

      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.getList()
        }, 500);
      }

    },

    onCopy(e) {
      Toast.success('复制成功');
    },
    onError(e) {
      console.log('复制失败！');
    },

    // 分享给家长
    onShareParent() {
      let that = this
      appEvent({
        name: 'shareWeixinFriend',
        query: that.share_data
      });
    },

    download(){
      console.log('donwload')
      let that = this;
      appEvent({
        name: 'downloadFile',
        query: {
          name: '运动员信息导入表模板',
          url:'https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2021-05-17/1621223399120721.xlsx'
        }
      });
    },


    action(item, index) {

      this.actionShow = true;
      this.params.id = item.id;
      this.params.name = item.name;
      this.formData2.id = item.id;
      this.formData2.name = item.name;
      this.formData2.jianhuname = item.jianhuname;
      this.formData2.jianhunum = item.jianhunum;
      this.formData2.jianhuphone = item.jianhuphone;
      this.actions = [];
      if (item.is_show == 1) {
        this.actions.push({name: '隐藏'});
        this.actions.push({name: '修改监护人信息'});
      } else {
        this.actions.push({name: '显示'});
      }
      if (item.cert_status == 2) {
        this.actions.push({name: '认证'});
      } else {
      }

    },
    onActionSelect(action, index) {
              //  console.log(action); return ;
      let that = this; 
          if (action.name == '隐藏') {
            Dialog.confirm({
              title: '确认',
              message: '是否隐藏该运动员?',
            })
                .then(() => {
                  // on confirm
                  that.$api.post('/api/yundongyuan/hide', {
                    id: that.params.id
                  }, (res) => {
                    that.onRefresh();
                  }, (res) => {
                    Toast.fail(res.msg);
                  })

                })
                .catch(() => {
                  // on cancel
                });
          } else if (action.name == '显示') {
            that.$api.post('/api/yundongyuan/show', {
              id: that.params.id
            }, (res) => {
              that.onRefresh();
            }, (res) => {
              Toast.fail(res.msg);
            })
          } else if(action.name == '认证'){

            that.$api.post('/api/yundongyuan/cert', {
              id: that.params.id
            }, (res) => {
              that.onRefresh();
            }, (res) => {
              Toast.fail(res.msg);
            })

          }else if(action.name == '修改监护人信息'){
            that.jianhuFormShow = true; 

          }

          this.actionShow = false; 
 
 
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },

    onDateConfirm(date) {
      console.log('onDateConfirm', date);
      this.showDate = false;
      this.formData.birthday = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    submit() {

    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.cardtype = index + 1;
      this.showNumTypePicker = false;
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onFamilyIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.jianhuname = data.name;
      this.formData.jianhunum = data.cardNum;
      this.formData2.jianhuname = data.name;
      this.formData2.jianhunum = data.cardNum;
    },
    onIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.name = data.name;
      this.formData.num = data.cardNum;
    },
    onJianhuSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;
      that.$api.post('/api/yundongyuan/jianhuedit', that.formData2, (res) => {
        that.saveLoading = false;
        that.jianhuFormShow = false;
        that.onRefresh();
        that.formData2 = {
          name: '',
          num: '',
          huzhao: '',
          cardtype: 1,
          birthday: '',
          sex: 1,
          numTypeName: '身份证',
          jianhuname: '',
          jianhunum: '',
          jianhuphone: '',
        };
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },


    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;
      that.$api.post('/api/yundongyuan/add', that.formData, (res) => {
        that.saveLoading = false;
        that.addShow = false;
        that.onRefresh();
        that.formData = {
          name: '',
          num: '',
          huzhao: '',
          cardtype: 1,
          birthday: '',
          sex: 1,
          numTypeName: '身份证',
          jianhuname: '',
          jianhunum: '',
          jianhuphone: '',
        };
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    onTongbu(){
      let that = this;
      that.$api.post('/api/yundongyuan/tongbuCca', {}, (res) => {
        Toast(res.msg);
        that.onRefresh();
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    // 更改状态
    onStatusChange(index) {

      let that = this;
      that.params.is_show = index + 1;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.is_show = 0;
      that.getList()
    },

            getCode(type) {
                let that = this;
                if (that.clockSecond > 0) {
                    return;
                }
                let phone = type==2?that.formData2.jianhuphone:that.formData.jianhuphone;
                if (!phone) {
                    Toast('请输入手机号')
                    return;
                }
                /*if (!that.formData.code) {
                    Toast('请输入验证码')
                    return;
                }*/
                that.$api.get('/api/index/phonecode', {phone: phone}, (res) => {
                    Toast(res.msg);
                })

                that.clockSecond = 60;

                var t = setInterval(function () {
                    if (that.clockSecond > 0) {
                        that.clockSecond = that.clockSecond - 1;
                    } else {
                        clearInterval(t);
                    }
                }, 1000)
            }


  }
}
</script>



// WEBPACK FOOTER //
// YundongyuanList.vue?2618927b